import {
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Card,
  CardHeader,
  Button,
  CardContent,
  Autocomplete,
  TextField,
  Stack,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  CircularProgress,
  Menu,
  Fade,
  ListItemIcon,
  MenuItem,
  Badge,
  Alert,
  Snackbar,
  Select,
} from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { useEffect, useMemo, useRef, useState } from "react";
import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import GanttChart from "../../components/Dashboard/GanttChart";
import {
  Ticket,
  DataOrder,
  TicketStatus,
  displayStatusCompany,
  PaginationResponse,
} from "../../common/constants";
import axiosConfig from "../../axiosConfig";
import { useSearchParams } from "react-router-dom";
import TicketDetail from "../TicketDetail";
import { Close, InfoOutlined, MoreVert, SaveAlt } from "@mui/icons-material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { jaJP } from "@mui/x-data-grid/locales";
import LoadingDialog from "../../components/LoadingDialog/LoadingDialog";
import { getformatDateFromISOFormat } from "../../components/Utils/utils";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ConfirmDialog, {
  ConfirmDialogType,
} from "../../components/Dashboard/ConfirmDialog";
import DownloadImageDialog from "../../components/Dashboard/DownloadImageDialog";
import OrderDetails from "../../components/Dashboard/OrderDetails";

// 受注確定/拒否などの操作が失敗したときに共通で表示する警告
const FAILURE_TOAST_MESSAGE = "処理に失敗しました 再度実行してください";

// CSVのファイル名（サーバー側 orders_%Y%m%d_%H%M%S.csv と同じ形式）
const buildCsvFileName = () => {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, "0");
  const date = `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`;
  const time = `${p(d.getHours())}${p(d.getMinutes())}${p(d.getSeconds())}`;
  return `orders_${date}_${time}.csv`;
};

// トーストを画面中央に固定するための位置指定
const CENTER_TOAST_POSITION = {
  top: "50%",
  bottom: "auto",
  left: "50%",
  right: "auto",
  transform: "translate(-50%, -50%)",
} as const;

function Row(props: {
  row: DataOrder;
  setTicketId: React.Dispatch<React.SetStateAction<string | undefined>>;
  setTicketIdSubDialog: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  fetchData: () => void;
  setOrderTicketId: React.Dispatch<React.SetStateAction<string | undefined>>;
  isExpanded: boolean;
  onToggleExpand: (orderId: string) => void;
  showToast: (message: string, severity?: "success" | "error") => void;
  selectedTicketIds: Set<string>;
  onToggleTicketSelection: (ticketId: string) => void;
  onSingleReject: (ticket: Ticket, estimationNumber: string) => void;
}) {
  const {
    row,
    setTicketId,
    setTicketIdSubDialog,
    isExpanded,
    onToggleExpand,
    showToast,
    selectedTicketIds,
    onToggleTicketSelection,
    onSingleReject,
  } = props;
  const open = isExpanded;
  const setOpen = (_value?: boolean) => onToggleExpand(row.order.id);
  const [dialogType, setDialogType] = useState<ConfirmDialogType | null>(null);
  const [openAcceptOrRejectDialog, setOpenAcceptOrRejectDialog] =
    useState(false);
  // 自社検品の受入拒否（やり直し依頼）の理由入力
  const [openRedoReasonDialog, setOpenRedoReasonDialog] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const [openDownloadDialog, setOpenDownloadDialog] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [imageData, setImageData] = React.useState<string | null>(null);
  const [imageName, setImageName] = React.useState<string | null>(null);
  const [selectedTicket, setSelectedTicket] = React.useState<Ticket>();
  const [isRefresh, setIsRefresh] = React.useState(false);

  const handleDownloadIntialFileClick = async () => {
    setImageData(null);
    setOpenDownloadDialog(true);
    setLoading(true);

    try {
      const response = await axiosConfig({
        method: "get",
        url: `/image/download-init/${selectedTicket?.id}`,
      });

      // Store image data & filename in state
      setImageData(response.data);
      setImageName(selectedTicket!.file_name);
    } catch (error) {
      console.error("Error downloading file", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadResultFileClick = async () => {
    setImageData(null);
    setOpenDownloadDialog(true);
    setLoading(true);

    try {
      const res = await axiosConfig({
        method: "get",
        url: `/image/download-res/${selectedTicket?.id}`,
      });

      // Store image data & filename in state
      setImageData(res.data.body.file_content);
      setImageName(res.data.body.file_name);

      if (
        TicketStatus.indexOf("SUB_DELIVERED") === selectedTicket?.status ||
        ((TicketStatus.indexOf("SUB_DELIVERY_LATE") ===
          selectedTicket?.status ||
          TicketStatus.indexOf("COMPANY_DELIVERY_LATE") ===
            selectedTicket?.status) &&
          selectedTicket?.previous_status ===
            TicketStatus.indexOf("SUB_DELIVERED"))
      ) {
        await axiosConfig.patch(`/dashboard/tickets/${selectedTicket?.id}`, {
          status: TicketStatus.indexOf("COMPANY_INSPECTION_ONGOING"),
        });
        setIsRefresh(true);
      }
    } catch (error) {
      console.error("Error downloading file", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDownloadDialog(false);
  };

  const handleDownloadFromDialog = () => {
    if (imageData) {
      // Decode base64 string
      const byteCharacters = atob(imageData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Create a Blob object with the correct MIME type
      const blob = new Blob([byteArray], {
        type: `image/${imageName?.split(".").pop() || "png"}`,
      });

      // Create a URL for the Blob object
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", imageName || "file");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleConfirmButtonClicked = async () => {
    if (selectedTicket) {
      try {
        if (dialogType === ConfirmDialogType.employeeConfirmDelivery) {
          await axiosConfig.post(`/dashboard/employee-deliver`, {
            ticket_id: selectedTicket.id,
          });
          props.fetchData();
          setOpenAcceptOrRejectDialog(false);
          return;
        }

        let status = 0;
        let progress = null;
        let toastMessage = "";
        if (dialogType === ConfirmDialogType.employeeAcceptCustomer) {
          status = TicketStatus.indexOf("COMPANY_ORDER_RECEIVED");
          toastMessage = "受注確定しました";
        } else if (
          dialogType === ConfirmDialogType.employeeAcceptSubcontractor
        ) {
          status = TicketStatus.indexOf("COMPANY_INSPECTION_COMPLETED");
        }
        await axiosConfig.patch(`/dashboard/tickets/${selectedTicket.id}`, {
          status: status,
          progress: progress,
        });

        if (toastMessage) {
          showToast(toastMessage);
        }
        props.fetchData();
      } catch (error) {
        console.error("Failed to update ticket status", error);
        showToast(FAILURE_TOAST_MESSAGE, "error");
      }
    }
    setOpenAcceptOrRejectDialog(false);
  };

  // 協力会社へのやり直し依頼。理由は協力会社向けコメントとメールで伝わる（BE で登録・送信）
  const handleRedoRequest = async (reason: string) => {
    if (!selectedTicket) return;
    try {
      await axiosConfig.patch(`/dashboard/tickets/${selectedTicket.id}`, {
        status: TicketStatus.indexOf("COMPANY_REDO_REQUESTED"),
        progress: 0,
        reason,
      });
      setOpenRedoReasonDialog(false);
      showToast("やり直しを依頼しました");
      props.fetchData();
    } catch (error) {
      console.error("Failed to request redo", error);
      showToast(FAILURE_TOAST_MESSAGE, "error");
    }
  };

  const changeBackgroundColor = (ticket: Ticket) => {
    if (ticket.deadline_alert_sent === 1) return "#fdffb6";
    if (
      ticket.status === 10 ||
      ticket.status === 5 ||
      ticket.deadline_alert_sent === 2
    )
      return "#fae0e4";
    return;
  };

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
        }}
      >
        <TableCell sx={{ width: "30px" }}>
          {row.tickets.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell
          sx={{
            width: "10%",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {(row.order.unread_comment_count ?? 0) > 0 && (
              <Badge
                color="error"
                badgeContent={row.order.unread_comment_count}
                sx={{ mr: 1 }}
              />
            )}
            <span>{row.order.estimation_number}</span>
          </Box>
        </TableCell>
        <TableCell
          sx={{
            width: "30%",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {row.order.project_name}
        </TableCell>
        <TableCell
          sx={{
            width: "15%",
          }}
        >
          {row.order.pic}
        </TableCell>
        <TableCell
          sx={{
            width: "15%",
          }}
        >
          {row.order.pic_ruby}
        </TableCell>
        <TableCell
          sx={{
            width: "10%",
          }}
        >
          {row.order.phone_number}
        </TableCell>
        <TableCell>
          <div style={{ display: "flex" }}>
            <Button
              variant="contained"
              size="small"
              disableRipple
              sx={{ marginLeft: "auto" }}
              onClick={() => {
                props.setOrderTicketId(row.tickets[0].id);
              }}
              disableElevation
            >
              詳細
            </Button>
          </div>
        </TableCell>
      </TableRow>
      {row.tickets.length > 0 && (
        <TableRow>
          <TableCell sx={{ padding: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Table
                size="small"
                sx={{
                  width: "100%",
                  tableLayout: "fixed",
                }}
              >
                <TableBody>
                  {row.tickets
                    .filter((ticketRow) => {
                      return ticketRow.id !== null;
                    })
                    .map((ticketRow: Ticket) => {
                      return (
                        <React.Fragment key={ticketRow.id}>
                          <TableRow
                            key={ticketRow.id}
                            sx={{
                              backgroundColor: changeBackgroundColor(ticketRow),
                            }}
                          >
                            <TableCell
                              sx={{
                                width: "5%",
                              }}
                            >
                              {TicketStatus[ticketRow.status] ===
                                "CUSTOMER_ORDERED" && (
                                <Checkbox
                                  size="small"
                                  checked={selectedTicketIds.has(ticketRow.id)}
                                  onChange={() =>
                                    onToggleTicketSelection(ticketRow.id)
                                  }
                                />
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                width: "30%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {ticketRow.file_name}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                width: "15%",
                              }}
                            >
                              {getformatDateFromISOFormat(
                                ticketRow.delivery_at
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                width: "20%",
                              }}
                            >
                              {
                                displayStatusCompany[
                                  TicketStatus[ticketRow.status]
                                ]
                              }
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                }}
                              >
                                {(TicketStatus[ticketRow.status] ===
                                  "COMPANY_ORDER_RECEIVED" ||
                                  TicketStatus[ticketRow.status] ===
                                    "CUSTOMER_DELIVERY_REJECTED" ||
                                  TicketStatus[ticketRow.status] ===
                                    "SUB_ORDER_REJECTED" ||
                                  ((TicketStatus[ticketRow.status] ===
                                    "COMPANY_DELIVERY_LATE" ||
                                    TicketStatus[ticketRow.status] ===
                                      "SUB_DELIVERY_LATE") &&
                                    (TicketStatus[ticketRow.previous_status] ===
                                      "COMPANY_ORDER_RECEIVED" ||
                                      TicketStatus[
                                        ticketRow.previous_status
                                      ] === "CUSTOMER_DELIVERY_REJECTED" ||
                                      TicketStatus[
                                        ticketRow.previous_status
                                      ] === "SUB_ORDER_REJECTED"))) && (
                                  <Stack spacing={2} direction="row">
                                    {TicketStatus[ticketRow.status] ===
                                      "CUSTOMER_DELIVERY_REJECTED" && (
                                      <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        disableRipple
                                        onClick={() => {
                                          setSelectedTicket(ticketRow);
                                          setDialogType(
                                            ConfirmDialogType.employeeConfirmDelivery
                                          );
                                          setOpenAcceptOrRejectDialog(true);
                                        }}
                                        disableElevation
                                      >
                                        再配送
                                      </Button>
                                    )}
                                    <Button
                                      variant="contained"
                                      size="small"
                                      disableRipple
                                      onClick={() => {
                                        setTicketIdSubDialog(ticketRow.id);
                                      }}
                                      disableElevation
                                    >
                                      チケット個別アサイン
                                    </Button>
                                  </Stack>
                                )}
                                {(TicketStatus[ticketRow.status] ===
                                  "CUSTOMER_ORDERED" ||
                                  ((TicketStatus[ticketRow.status] ===
                                    "COMPANY_DELIVERY_LATE" ||
                                    TicketStatus[ticketRow.status] ===
                                      "SUB_DELIVERY_LATE") &&
                                    TicketStatus[ticketRow.previous_status] ===
                                      "CUSTOMER_ORDERED")) && (
                                  <Stack
                                    spacing={2}
                                    direction="row"
                                    sx={{ marginLeft: "auto" }}
                                  >
                                    <Button
                                      variant="contained"
                                      size="small"
                                      disableRipple
                                      disableElevation
                                      style={{
                                        backgroundColor: "#DAE8FC",
                                        color: "#000",
                                      }}
                                      onClick={() => {
                                        setSelectedTicket(ticketRow);
                                        setDialogType(
                                          ConfirmDialogType.employeeAcceptCustomer
                                        );
                                        setOpenAcceptOrRejectDialog(true);
                                      }}
                                    >
                                      受注確定
                                    </Button>
                                    <Button
                                      variant="contained"
                                      size="small"
                                      disableRipple
                                      disableElevation
                                      color="error"
                                      style={{
                                        backgroundColor: "#F8CECC",
                                        color: "#000",
                                      }}
                                      onClick={() => {
                                        onSingleReject(
                                          ticketRow,
                                          row.order.estimation_number
                                        );
                                      }}
                                    >
                                      受注拒否
                                    </Button>
                                  </Stack>
                                )}
                                {(TicketStatus[ticketRow.status] ===
                                  "COMPANY_INSPECTION_ONGOING" ||
                                  ((TicketStatus[ticketRow.status] ===
                                    "COMPANY_DELIVERY_LATE" ||
                                    TicketStatus[ticketRow.status] ===
                                      "SUB_DELIVERY_LATE") &&
                                    TicketStatus[ticketRow.previous_status] ===
                                      "COMPANY_INSPECTION_ONGOING")) && (
                                  <Stack
                                    spacing={2}
                                    direction="row"
                                    sx={{ marginLeft: "auto" }}
                                  >
                                    <Button
                                      variant="contained"
                                      size="small"
                                      disableRipple
                                      disableElevation
                                      onClick={() => {
                                        setSelectedTicket(ticketRow);
                                        setDialogType(
                                          ConfirmDialogType.employeeAcceptSubcontractor
                                        );
                                        setOpenAcceptOrRejectDialog(true);
                                      }}
                                    >
                                      受入完了
                                    </Button>
                                    <Button
                                      variant="contained"
                                      size="small"
                                      disableRipple
                                      disableElevation
                                      color="error"
                                      onClick={() => {
                                        setSelectedTicket(ticketRow);
                                        setOpenRedoReasonDialog(true);
                                      }}
                                    >
                                      受入拒否
                                    </Button>
                                  </Stack>
                                )}
                                {(TicketStatus[ticketRow.status] ===
                                  "COMPANY_INSPECTION_COMPLETED" ||
                                  ((TicketStatus[ticketRow.status] ===
                                    "COMPANY_DELIVERY_LATE" ||
                                    TicketStatus[ticketRow.status] ===
                                      "SUB_DELIVERY_LATE") &&
                                    TicketStatus[ticketRow.previous_status] ===
                                      "COMPANY_INSPECTION_COMPLETED")) && (
                                  <Button
                                    variant="contained"
                                    size="small"
                                    disableRipple
                                    disableElevation
                                    style={{
                                      backgroundColor: "#D5E8D4",
                                      color: "#000",
                                    }}
                                    onClick={() => {
                                      setSelectedTicket(ticketRow);
                                      setDialogType(
                                        ConfirmDialogType.employeeConfirmDelivery
                                      );
                                      setOpenAcceptOrRejectDialog(true);
                                    }}
                                  >
                                    納品する
                                  </Button>
                                )}
                                <IconButton
                                  id={ticketRow.id}
                                  aria-controls={
                                    openMenu ? "fade-menu" : undefined
                                  }
                                  aria-haspopup="true"
                                  aria-expanded={openMenu ? "true" : undefined}
                                  onClick={(
                                    event: React.MouseEvent<HTMLElement>
                                  ) => {
                                    setAnchorEl(event.currentTarget);
                                    setSelectedTicket(ticketRow);
                                  }}
                                  sx={{
                                    marginLeft: "20px",
                                  }}
                                >
                                  <MoreVert />
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
          <Menu
            MenuListProps={{
              "aria-labelledby": "fade-button",
            }}
            anchorEl={anchorEl}
            open={openMenu}
            onClose={() => {
              setAnchorEl(null);
            }}
            TransitionComponent={Fade}
          >
            <MenuItem
              onClick={() => {
                handleDownloadIntialFileClick();
                setImageName(selectedTicket!.file_name);
                setAnchorEl(null);
              }}
            >
              <ListItemIcon>
                <SaveAlt
                  sx={{
                    color: "#4CAF50",
                  }}
                />
              </ListItemIcon>
              <Typography
                variant="inherit"
                sx={{
                  color: "#4CAF50",
                }}
              >
                ファイル
              </Typography>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleDownloadResultFileClick();
                setAnchorEl(null);
              }}
            >
              <ListItemIcon>
                <SaveAlt
                  sx={{
                    color: "#4CAF50",
                  }}
                />
              </ListItemIcon>
              <Typography
                variant="inherit"
                sx={{
                  color: "#4CAF50",
                }}
              >
                納品物
              </Typography>
            </MenuItem>
            <MenuItem
              onClick={() => {
                setTicketId(selectedTicket?.id);
                setAnchorEl(null);
              }}
            >
              <ListItemIcon>
                <InfoOutlined
                  sx={{
                    color: "#3964B1",
                  }}
                />
              </ListItemIcon>
              <Typography
                variant="inherit"
                sx={{
                  color: "#3964B1",
                }}
              >
                詳細
              </Typography>
            </MenuItem>
          </Menu>
          <DownloadImageDialog
            open={openDownloadDialog}
            onClose={() => {
              handleCloseDialog();
              if (isRefresh) {
                props.fetchData();
                setIsRefresh(false);
              }
            }}
            imageName={imageName || ""}
            imageUrl={imageData || ""}
            imageType={`image/${
              selectedTicket?.file_name.split(".").pop() || "png"
            }`}
            onDownload={handleDownloadFromDialog}
            loading={loading}
          />
          <ConfirmDialog
            dialogType={dialogType!}
            open={openAcceptOrRejectDialog}
            onClose={() => {
              setOpenAcceptOrRejectDialog(false);
            }}
            onConfirm={handleConfirmButtonClicked}
            estimationNumber={row.order.estimation_number}
            fileName={selectedTicket?.file_name || ""}
          />
          <RejectReasonModal
            open={openRedoReasonDialog}
            onClose={() => setOpenRedoReasonDialog(false)}
            onConfirm={handleRedoRequest}
            title="受入拒否（やり直し依頼）"
            estimationNumber={row.order.estimation_number}
            fileName={selectedTicket?.file_name || ""}
            actionLabel="差し戻し"
            description="協力会社への差し戻し理由を入力してください（必須）。理由は協力会社にメールで届き、やりとり欄に残ります（お客様には表示されません）。"
          />
        </TableRow>
      )}
    </React.Fragment>
  );
}

type DashboardSummary = {
  order_waiting: number;
  reassign: number;
  failed_estimate: number;
  in_progress: number;
  inspection_waiting: number;
  overdue: number;
  order_rejected: number;
  pending_accounts: number;
};

// 見積不可タブに表示する案件（設計01 failed_estimates の社内向け全件）
type FailedEstimateItem = {
  id: string;
  file_name: string;
  s3_url_image: string | null;
  order_id: string | null;
  // 社内運用宛の通知メールを送った日時。問い合わせ状況の表示には使わない
  inquiry_sent_at: string | null;
  // 問い合わせ状況（社内が手動で切替）。null=未問い合わせ / 値あり=問い合わせ済み
  inquiry_handled_at: string | null;
  inquiry_handled_by: string | null;
  inquiry_handled_by_name: string | null;
  created_at: string | null;
  customer_name: string | null;
};

// 承認待ち顧客タブに表示する顧客（設計04）
type PendingAccountItem = {
  id: string;
  username: string;
  fullname: string;
  fullname_kana: string | null;
  email: string;
  phone_number: string | null;
  address: string | null;
  postal_code: string | null;
  created_at: string | null;
  approval_status: string;
  company_name: string | null;
  company_name_ruby: string | null;
};

type DashboardTab = {
  id: string;
  label: string;
  status?: string; // カンマ区切りステータス番号
  overdue?: boolean;
  adminOnly?: boolean;
  summaryKey: keyof DashboardSummary;
};

// 設計06 の分類タブ（受注不可タブは 2026-10-01 に要対応（再アサイン）から分離）
const DASHBOARD_TABS: DashboardTab[] = [
  {
    id: "order_waiting",
    label: "要対応（受注待ち）",
    status: "1",
    summaryKey: "order_waiting",
  },
  {
    id: "reassign",
    label: "要対応（再アサイン）",
    // 再アサインできるのは外注先受注拒否(9)のみ。自社受注拒否(4)は「受注不可」タブ。
    status: "9",
    summaryKey: "reassign",
  },
  {
    id: "failed_estimate",
    label: "見積不可",
    summaryKey: "failed_estimate",
  },
  {
    id: "in_progress",
    label: "作業中",
    status: "2,3,5,6,7,8,10,11,12,14,17",
    summaryKey: "in_progress",
  },
  {
    id: "inspection_waiting",
    label: "検収待ち",
    status: "13,15",
    summaryKey: "inspection_waiting",
  },
  {
    id: "overdue",
    label: "期限超過",
    overdue: true,
    summaryKey: "overdue",
  },
  {
    id: "order_rejected",
    label: "受注不可",
    status: "4",
    summaryKey: "order_rejected",
  },
  {
    id: "pending_accounts",
    label: "承認待ち顧客",
    adminOnly: true,
    summaryKey: "pending_accounts",
  },
];

// status/overdue を持たない特殊タブ（一覧は orders エンドポイントで表現できない）
const SPECIAL_TAB_IDS = ["failed_estimate", "pending_accounts"];

// searchParams から現在アクティブなタブIDを判定
function getActiveTabId(
  status: string,
  overdue: boolean,
  tabParam: string
): string | null {
  if (tabParam && SPECIAL_TAB_IDS.includes(tabParam)) return tabParam;
  if (overdue) return "overdue";
  if (!status) return null;
  const match = DASHBOARD_TABS.find((t) => t.status === status);
  return match ? match.id : null;
}

const EmployeeDashboard: React.FC = () => {
  const [showSearchContent, setShowSearchContent] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [data, setData] = useState<PaginationResponse<DataOrder>>({
    data: [],
    metadata: {
      page: 1,
      per_page: 10,
      page_count: 0,
      total_count: 0,
    },
  });
  const [ticketId, setTicketId] = useState<string>();
  const [orderTicketId, setOrderTicketId] = useState<string>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const isAdmin = useAppSelector((state) => state.accountInfo.roles.admin);

  const searchQuery = useRef({
    pic: "",
    project_name: "",
    file_name: "",
    estimation_number: "",
    status: "",
    overdue: "",
    accepted_from: "",
    accepted_to: "",
  });

  // 展開状態を order.id をキーにした Set で親管理（再読込後も維持）
  const [expandedOrders, setExpandedOrders] = useState<Set<string>>(new Set());
  const toggleExpand = (orderId: string) => {
    setExpandedOrders((prev) => {
      const next = new Set(prev);
      if (next.has(orderId)) next.delete(orderId);
      else next.add(orderId);
      return next;
    });
  };

  // 一括処理用の選択チケット
  const [selectedTicketIds, setSelectedTicketIds] = useState<Set<string>>(
    new Set()
  );
  const toggleTicketSelection = (ticketId: string) => {
    setSelectedTicketIds((prev) => {
      const next = new Set(prev);
      if (next.has(ticketId)) next.delete(ticketId);
      else next.add(ticketId);
      return next;
    });
  };

  // トースト
  const [toast, setToast] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({
    open: false,
    message: "",
    severity: "success",
  });
  const showToast = (
    message: string,
    severity: "success" | "error" = "success"
  ) => setToast({ open: true, message, severity });

  // タブ別件数サマリ
  const [summary, setSummary] = useState<DashboardSummary>({
    order_waiting: 0,
    reassign: 0,
    failed_estimate: 0,
    in_progress: 0,
    inspection_waiting: 0,
    overdue: 0,
    order_rejected: 0,
    pending_accounts: 0,
  });

  const fetchSummary = async () => {
    try {
      const response = await axiosConfig.get("/dashboard/orders/summary");
      setSummary(response.data.body);
    } catch (error) {
      console.error("Failed to fetch summary", error);
    }
  };

  // 見積不可タブ用の一覧（社内は全件・未問い合わせ含む）
  const [failedEstimates, setFailedEstimates] = useState<FailedEstimateItem[]>(
    []
  );
  const [failedEstimatesLoading, setFailedEstimatesLoading] = useState(false);
  const fetchFailedEstimates = async () => {
    setFailedEstimatesLoading(true);
    try {
      const response = await axiosConfig.get("/dashboard/failed-estimates");
      setFailedEstimates(response.data.body.data || []);
    } catch (error) {
      console.error("Failed to fetch failed estimates", error);
      setFailedEstimates([]);
    } finally {
      setFailedEstimatesLoading(false);
    }
  };

  // 問い合わせ状況の手動切替。問い合わせ自体が本システムの外で行われるため、
  // システムからは検知できず社内担当者が手で切り替える。
  const [inquiryUpdatingId, setInquiryUpdatingId] = useState<string | null>(
    null
  );
  const toggleInquiryStatus = async (
    item: FailedEstimateItem,
    handled: boolean
  ) => {
    setInquiryUpdatingId(item.id);
    try {
      const response = await axiosConfig.patch(
        `/dashboard/failed-estimates/${item.id}/inquiry-status`,
        { handled }
      );
      const updated = response.data.body;
      setFailedEstimates((prev) =>
        prev.map((row) =>
          row.id === item.id
            ? {
                ...row,
                inquiry_handled_at: updated.inquiry_handled_at ?? null,
                inquiry_handled_by: updated.inquiry_handled_by ?? null,
                inquiry_handled_by_name:
                  updated.inquiry_handled_by_name ?? null,
              }
            : row
        )
      );
      showToast(
        handled ? "問い合わせ済みにしました" : "未問い合わせに戻しました"
      );
    } catch (error) {
      console.error("Failed to update inquiry status", error);
      showToast(FAILURE_TOAST_MESSAGE, "error");
    } finally {
      setInquiryUpdatingId(null);
    }
  };

  // 承認待ち顧客タブ用の一覧（設計04、admin のみ）
  const [pendingAccounts, setPendingAccounts] = useState<PendingAccountItem[]>(
    []
  );
  const [pendingAccountsLoading, setPendingAccountsLoading] = useState(false);
  const fetchPendingAccounts = async () => {
    setPendingAccountsLoading(true);
    try {
      const response = await axiosConfig.get(
        "/dashboard/customers?approval_status=pending"
      );
      setPendingAccounts(response.data.body.data || []);
    } catch (error) {
      console.error("Failed to fetch pending accounts", error);
      setPendingAccounts([]);
    } finally {
      setPendingAccountsLoading(false);
    }
  };

  // 承認画面（顧客詳細ダイアログ）で開いている顧客
  const [selectedAccount, setSelectedAccount] =
    useState<PendingAccountItem | null>(null);
  const [approvalProcessing, setApprovalProcessing] = useState(false);
  const handleApproval = async (
    account: PendingAccountItem,
    action: "approve" | "reject"
  ) => {
    setApprovalProcessing(true);
    try {
      await axiosConfig.patch(
        `/dashboard/customers/${account.id}/approval`,
        { action }
      );
      showToast(action === "approve" ? "顧客を承認しました" : "顧客を拒否しました");
      setSelectedAccount(null);
      fetchPendingAccounts();
      fetchSummary();
    } catch (error) {
      console.error("Failed to update approval", error);
      showToast("処理に失敗しました。時間をおいて再度お試しください。", "error");
    } finally {
      setApprovalProcessing(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const url = "/dashboard/orders";

    let queryString = "";
    for (const key in searchQuery.current) {
      if (searchQuery.current[key as keyof typeof searchQuery.current]) {
        queryString += queryString !== "" ? "&" : "?";
        queryString += `${key}=${
          searchQuery.current[key as keyof typeof searchQuery.current]
        }`;
      }
    }
    const response = await axiosConfig.get(`${url}${queryString}`);
    setData(response.data.body);
    setLoading(false);
    // 選択は再読込のたびにクリア（状態変化後の混在防止）
    setSelectedTicketIds(new Set());
    fetchSummary();
  };

  const handleSearch = () => {
    setSearchParams((params) => {
      for (const key in searchQuery.current) {
        if (searchQuery.current[key as keyof typeof searchQuery.current]) {
          params.set(
            key,
            String(searchQuery.current[key as keyof typeof searchQuery.current])
          );
        } else {
          params.delete(key);
        }
      }
      return params;
    });
  };

  useEffect(() => {
    searchQuery.current = {
      pic: searchParams.get("pic") || "",
      project_name: searchParams.get("project_name") || "",
      file_name: searchParams.get("file_name") || "",
      estimation_number: searchParams.get("estimation_number") || "",
      status: searchParams.get("status") || "",
      overdue: searchParams.get("overdue") || "",
      accepted_from: searchParams.get("accepted_from") || "",
      accepted_to: searchParams.get("accepted_to") || "",
    };

    fetchData();
    // 見積不可タブ表示時は一覧も取得（社内は全件）
    if ((searchParams.get("tab") || "") === "failed_estimate") {
      fetchFailedEstimates();
    }
    // 承認待ち顧客タブ表示時は一覧を取得（設計04、admin のみ）
    if ((searchParams.get("tab") || "") === "pending_accounts") {
      fetchPendingAccounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // 現在アクティブなタブ判定（searchParams から復元）
  const activeTabId = useMemo(() => {
    return getActiveTabId(
      searchParams.get("status") || "",
      searchParams.get("overdue") === "true",
      searchParams.get("tab") || ""
    );
  }, [searchParams]);

  // タブ選択: status/overdue/tab を searchParams に反映（他の自由検索フィルタは維持）
  const handleTabClick = (tab: DashboardTab) => {
    setSelectedIndex(0);
    setTicketId(undefined);
    setSearchParams((params) => {
      // まず分類系パラメータをクリア
      params.delete("status");
      params.delete("overdue");
      params.delete("tab");
      if (SPECIAL_TAB_IDS.includes(tab.id)) {
        params.set("tab", tab.id);
      } else if (tab.overdue) {
        params.set("overdue", "true");
      } else if (tab.status) {
        params.set("status", tab.status);
      }
      return params;
    });
  };

  const specialTab = searchParams.get("tab") || "";

  const handleListItemClick = async (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
    setTicketId(undefined);
  };

  const [ticketIdSubDialog, setTicketIdSubDialog] = useState<string>();
  // お客様に受入拒否された図面の再依頼は、協力会社への差し戻し理由が必須
  const subDialogRequiresReason = useMemo(
    () =>
      data.data.some((row) =>
        row.tickets.some(
          (ticket) =>
            ticket.id === ticketIdSubDialog &&
            ticket.status === TicketStatus.indexOf("CUSTOMER_DELIVERY_REJECTED")
        )
      ),
    [data, ticketIdSubDialog]
  );

  // 一括処理・単件受注拒否モーダルの状態
  const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);
  const [bulkReject, setBulkReject] = useState(false);
  const [bulkReasonOpen, setBulkReasonOpen] = useState(false);
  const [singleReject, setSingleReject] = useState<{
    ticket: Ticket;
    estimationNumber: string;
  } | null>(null);

  // 選択済みチケットの集計（確認ダイアログ表示用）
  const selectedSummary = useMemo(() => {
    let totalQuantity = 0;
    let totalAmount = 0;
    const customerCounts: Record<string, number> = {};
    for (const row of data.data) {
      for (const ticket of row.tickets) {
        if (selectedTicketIds.has(ticket.id)) {
          totalQuantity += 1;
          totalAmount += Number(ticket.amount) || 0;
          const key = row.order.pic || row.order.customer_name || "（不明）";
          customerCounts[key] = (customerCounts[key] || 0) + 1;
        }
      }
    }
    return {
      count: selectedTicketIds.size,
      totalQuantity,
      totalAmount,
      customerCounts,
    };
  }, [selectedTicketIds, data]);

  const allTicketIds = useMemo(() => {
    return data.data
      .map((row) =>
        row.tickets
          .filter((ticket) =>
            // 受入拒否された図面は差し戻し理由が必要なため、個別アサインのみ
            [
              TicketStatus.indexOf("COMPANY_ORDER_RECEIVED"),
              TicketStatus.indexOf("SUB_ORDER_REJECTED"),
            ].includes(ticket.status)
          )
          .map((ticket) => ticket.id)
      )
      .flat();
  }, [data]);

  // 一括受注確定/拒否の実行
  const executeBulk = async (status: number, reason?: string) => {
    try {
      await axiosConfig.post("/dashboard/tickets/bulk-status", {
        ticket_ids: Array.from(selectedTicketIds),
        status,
        reason,
      });
      showToast(
        status === TicketStatus.indexOf("COMPANY_ORDER_RECEIVED")
          ? "受注確定しました"
          : "受注拒否しました"
      );
      fetchData();
    } catch (error) {
      console.error("Failed to update tickets in bulk", error);
      showToast(FAILURE_TOAST_MESSAGE, "error");
    }
  };

  // 単件受注拒否（理由必須モーダル経由）
  const executeSingleReject = async (ticketId: string, reason: string) => {
    try {
      await axiosConfig.post("/dashboard/tickets/bulk-status", {
        ticket_ids: [ticketId],
        status: TicketStatus.indexOf("COMPANY_ORDER_REJECTED"),
        reason,
      });
      showToast("受注拒否しました");
      fetchData();
    } catch (error) {
      console.error("Failed to reject a ticket", error);
      showToast(FAILURE_TOAST_MESSAGE, "error");
    }
  };

  // CSVエクスポート（現在の検索条件をクエリに載せる）
  const handleExportCsv = async () => {
    let queryString = "";
    for (const key in searchQuery.current) {
      if (searchQuery.current[key as keyof typeof searchQuery.current]) {
        queryString += queryString !== "" ? "&" : "?";
        queryString += `${key}=${
          searchQuery.current[key as keyof typeof searchQuery.current]
        }`;
      }
    }
    const response = await axiosConfig.get(
      `/dashboard/orders/export${queryString}`,
      { responseType: "text" }
    );
    // サーバーは Excel 対応のため UTF-8 BOM を付けて返すが、XHR/fetch の
    // テキスト変換（WHATWG "UTF-8 decode"）が先頭の BOM を取り除いてしまう。
    // そのまま Blob 化すると BOM なしの UTF-8 になり、Excel が Shift_JIS と
    // 誤認して文字化けする。剥がれていてもいなくても BOM が必ず1つになるよう
    // 付け直す。
    const BOM = "\uFEFF";
    const csvText = String(response.data).replace(new RegExp("^" + BOM), "");
    const blob = new Blob([BOM + csvText], {
      type: "text/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const disposition = response.headers["content-disposition"] || "";
    const match = disposition.match(/filename="?([^"]+)"?/);
    link.href = url;
    // サーバーのファイル名（orders_日付_時刻.csv）を使う。
    // ヘッダが読めなかった場合も日時なしの名前にならないよう、
    // クライアント側の時刻で同じ形式を組み立てる。
    link.setAttribute("download", match ? match[1] : buildCsvFileName());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // 期限超過タブへ遷移
  const goToOverdueTab = () => {
    setSelectedIndex(0);
    setSearchParams((params) => {
      params.set("overdue", "true");
      params.delete("status");
      // 見積不可/承認待ちなど特殊タブ滞在中でも確実に期限超過タブへ遷移する。
      params.delete("tab");
      return params;
    });
  };

  // 表示するタブ（承認待ち顧客は admin のみ）
  const visibleTabs = useMemo(
    () => DASHBOARD_TABS.filter((t) => !t.adminOnly || isAdmin),
    [isAdmin]
  );

  return (
    <>
      <div className=" flex flex-col">
        <Header pageTitle="自社ダッシュボード"></Header>
        {summary.overdue > 0 && (
          <Alert
            severity="warning"
            sx={{ borderRadius: 0 }}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={goToOverdueTab}
              >
                一覧を表示
              </Button>
            }
          >
            ⚠ 期限超過の案件が {summary.overdue}件 あります
          </Alert>
        )}
        <Grid container sx={{ height: "90vh" }} className="pb-6">
          <Grid item xs={1.5} className="py-2 bg-gray-100 h-full">
            <List component="nav" sx={{ color: "#3E6EB4" }}>
              {visibleTabs.map((tab) => {
                const isActive = selectedIndex === 0 && activeTabId === tab.id;
                const count = summary[tab.summaryKey] ?? 0;
                return (
                  <ListItemButton
                    key={tab.id}
                    selected={isActive}
                    onClick={() => handleTabClick(tab)}
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor: "#3E6EB4",
                        color: "#fff",
                      },
                    }}
                  >
                    <ListAltIcon className="mr-2" />
                    <ListItemText primary={tab.label} />
                    <Badge
                      badgeContent={count}
                      color={isActive ? "default" : "primary"}
                      max={999}
                      showZero
                      sx={{ mr: 1 }}
                    />
                  </ListItemButton>
                );
              })}

              <ListItemButton
                selected={selectedIndex === 1}
                onClick={(event) => handleListItemClick(event, 1)}
                sx={{
                  mt: 1,
                  "&.Mui-selected": {
                    backgroundColor: "#3E6EB4",
                    color: "#fff",
                  },
                }}
              >
                <AnalyticsIcon className="mr-4" />
                <ListItemText primary="ガントチャート" />
              </ListItemButton>
            </List>
          </Grid>
          <Grid
            item
            xs={10.5}
            className="h-full pb-6 pt-4 px-4"
            sx={{ overflowX: "hidden", overflowY: "scroll" }}
          >
            {selectedIndex === 0 ? (
              <>
                <Card
                  className="mx-auto w-full"
                  sx={{ border: 1, borderColor: "grey.300" }}
                >
                  <CardHeader
                    sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                    subheader={
                      <Button
                        variant="text"
                        sx={{ padding: 0, color: "black" }}
                        disableRipple={true}
                        onClick={() => setShowSearchContent(!showSearchContent)}
                      >
                        絞り込み
                      </Button>
                    }
                  />
                  {showSearchContent && (
                    <CardContent sx={{ paddingY: "5px" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <h3>顧客名</h3>
                          <Autocomplete
                            freeSolo
                            className="mt-1"
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} />}
                            options={[
                              ...new Set(
                                data.data.map((row: DataOrder) => row.order.pic)
                              ),
                            ]}
                            value={searchQuery.current.pic}
                            onInputChange={(event, value) => {
                              searchQuery.current.pic = value;
                            }}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <h3>案件名</h3>
                          <Autocomplete
                            freeSolo
                            className="mt-1"
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} />}
                            options={[
                              ...new Set(
                                data.data.map(
                                  (row: DataOrder) => row.order.project_name
                                )
                              ),
                            ]}
                            value={searchQuery.current.project_name}
                            onInputChange={(event, value) => {
                              searchQuery.current.project_name = value;
                            }}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <h3>ファイル名</h3>
                          <Autocomplete
                            freeSolo
                            className="mt-1"
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} />}
                            options={[
                              ...new Set(
                                data.data
                                  .map((row) =>
                                    row.tickets.map(
                                      (ticket) => ticket.file_name
                                    )
                                  )
                                  .flat()
                              ),
                            ]}
                            value={searchQuery.current.file_name}
                            onInputChange={(_, value) =>
                              (searchQuery.current.file_name = value)
                            }
                            getOptionLabel={(option) => option || ""}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <h3>見積番号</h3>
                          <Autocomplete
                            freeSolo
                            className="mt-1"
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} />}
                            options={[
                              ...new Set(
                                data.data.map(
                                  (row: DataOrder) =>
                                    row.order.estimation_number
                                )
                              ),
                            ]}
                            value={searchQuery.current.estimation_number}
                            onInputChange={(event, value) => {
                              searchQuery.current.estimation_number = value;
                            }}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <h3>受付日（From）</h3>
                          <TextField
                            type="date"
                            className="mt-1"
                            size="small"
                            fullWidth
                            defaultValue={searchQuery.current.accepted_from}
                            onChange={(e) => {
                              searchQuery.current.accepted_from = e.target.value;
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <h3>受付日（To）</h3>
                          <TextField
                            type="date"
                            className="mt-1"
                            size="small"
                            fullWidth
                            defaultValue={searchQuery.current.accepted_to}
                            onChange={(e) => {
                              searchQuery.current.accepted_to = e.target.value;
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                      </Grid>
                      <Stack
                        className="mt-1"
                        direction="row"
                        spacing={2}
                        justifyContent="flex-end"
                      >
                        <Button
                          variant="outlined"
                          startIcon={<SaveAlt />}
                          onClick={handleExportCsv}
                        >
                          CSVエクスポート
                        </Button>
                        <Button
                          variant="contained"
                          sx={{ paddingX: "30px" }}
                          onClick={() => handleSearch()}
                        >
                          検索
                        </Button>
                      </Stack>
                    </CardContent>
                  )}
                </Card>
                <Card
                  className="mx-auto w-full mt-4"
                  sx={{ width: "100%", border: 1, borderColor: "grey.300" }}
                >
                  <CardHeader
                    sx={{ bgcolor: "#F5F5F5", paddingY: "10px" }}
                    subheader={"案件リスト"}
                    action={
                      <Stack direction="row" spacing={1} alignItems="center">
                        {selectedTicketIds.size > 0 && (
                          <>
                            <Button
                              variant="contained"
                              size="small"
                              disableRipple
                              onClick={() => setBulkConfirmOpen(true)}
                            >
                              選択した{selectedTicketIds.size}件を一括受注確定
                            </Button>
                            <Button
                              variant="contained"
                              size="small"
                              color="error"
                              disableRipple
                              onClick={() => {
                                setBulkReject(true);
                                setBulkReasonOpen(true);
                              }}
                            >
                              選択した{selectedTicketIds.size}件を一括受注拒否
                            </Button>
                          </>
                        )}
                        {!loading && data.data.length > 0 && (
                          <AssignAllTicketsButton
                            ticketIds={allTicketIds}
                            refreshData={fetchData}
                          />
                        )}
                      </Stack>
                    }
                  ></CardHeader>
                  <CardContent>
                    {specialTab === "failed_estimate" ? (
                      <Box>
                        <Typography sx={{ mb: 2 }}>
                          見積不可の案件が {summary.failed_estimate}件
                          あります（未問い合わせ含む）。
                        </Typography>
                        {failedEstimatesLoading ? (
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              paddingY: 10,
                            }}
                          >
                            <CircularProgress
                              sx={{
                                marginLeft: "auto",
                                marginRight: "auto",
                              }}
                            />
                          </Box>
                        ) : failedEstimates.length === 0 ? (
                          <Box sx={{ paddingY: 6, textAlign: "center" }}>
                            <Typography color="text.secondary">
                              データがありません。
                            </Typography>
                          </Box>
                        ) : (
                          <TableContainer component={Paper}>
                            <Table size="small" aria-label="failed estimates">
                              <TableHead>
                                <TableRow>
                                  <TableCell>顧客名</TableCell>
                                  <TableCell>ファイル名</TableCell>
                                  <TableCell>アップロード日時</TableCell>
                                  <TableCell>問い合わせ状況</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {failedEstimates.map((item) => (
                                  <TableRow key={item.id}>
                                    <TableCell>
                                      {item.customer_name || "（不明）"}
                                    </TableCell>
                                    <TableCell>{item.file_name}</TableCell>
                                    <TableCell>
                                      {item.created_at
                                        ? new Date(
                                            item.created_at
                                          ).toLocaleString("ja-JP")
                                        : "-"}
                                    </TableCell>
                                    <TableCell>
                                      <Select
                                        size="small"
                                        value={
                                          item.inquiry_handled_at
                                            ? "handled"
                                            : "not_handled"
                                        }
                                        disabled={inquiryUpdatingId === item.id}
                                        onChange={(e) =>
                                          toggleInquiryStatus(
                                            item,
                                            e.target.value === "handled"
                                          )
                                        }
                                        sx={{ minWidth: 150 }}
                                      >
                                        <MenuItem value="not_handled">
                                          未問い合わせ
                                        </MenuItem>
                                        <MenuItem value="handled">
                                          問い合わせ済み
                                        </MenuItem>
                                      </Select>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </Box>
                    ) : specialTab === "pending_accounts" && isAdmin ? (
                      <Box>
                        <Typography sx={{ mb: 2 }}>
                          承認待ちの顧客が {summary.pending_accounts}件
                          あります。行をクリックすると詳細を確認し、承認/拒否ができます。
                        </Typography>
                        {pendingAccountsLoading ? (
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              paddingY: 10,
                            }}
                          >
                            <CircularProgress
                              sx={{
                                marginLeft: "auto",
                                marginRight: "auto",
                              }}
                            />
                          </Box>
                        ) : pendingAccounts.length === 0 ? (
                          <Box sx={{ paddingY: 6, textAlign: "center" }}>
                            <Typography color="text.secondary">
                              承認待ちの顧客はいません。
                            </Typography>
                          </Box>
                        ) : (
                          <TableContainer component={Paper}>
                            <Table size="small" aria-label="pending accounts">
                              <TableHead>
                                <TableRow>
                                  <TableCell>登録日</TableCell>
                                  <TableCell>会社名</TableCell>
                                  <TableCell>氏名</TableCell>
                                  <TableCell>メール</TableCell>
                                  <TableCell>電話番号</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {pendingAccounts.map((item) => (
                                  <TableRow
                                    key={item.id}
                                    hover
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => setSelectedAccount(item)}
                                  >
                                    <TableCell>
                                      {item.created_at
                                        ? new Date(
                                            item.created_at
                                          ).toLocaleString("ja-JP")
                                        : "-"}
                                    </TableCell>
                                    <TableCell>
                                      {item.company_name || "-"}
                                    </TableCell>
                                    <TableCell>{item.fullname}</TableCell>
                                    <TableCell>{item.email}</TableCell>
                                    <TableCell>
                                      {item.phone_number || "-"}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </Box>
                    ) : (
                      <TableContainer component={Paper}>
                        <Table aria-label="collapsible table" size="small">
                          {loading && (
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                paddingY: 10,
                              }}
                            >
                              <CircularProgress
                                sx={{
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                }}
                              />
                            </Box>
                          )}
                          {!loading && data.data.length === 0 && (
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                paddingY: 10,
                              }}
                            >
                              <p
                                style={{
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                }}
                              >
                                データがありません。
                              </p>
                            </Box>
                          )}
                          {!loading && data.data.length > 0 && (
                            <TableBody>
                              {data.data.map((row: DataOrder) => (
                                <Row
                                  key={row.order.id}
                                  row={row}
                                  setTicketId={setTicketId}
                                  setTicketIdSubDialog={setTicketIdSubDialog}
                                  fetchData={fetchData}
                                  setOrderTicketId={setOrderTicketId}
                                  isExpanded={expandedOrders.has(row.order.id)}
                                  onToggleExpand={toggleExpand}
                                  showToast={showToast}
                                  selectedTicketIds={selectedTicketIds}
                                  onToggleTicketSelection={
                                    toggleTicketSelection
                                  }
                                  onSingleReject={(ticket, estimationNumber) =>
                                    setSingleReject({
                                      ticket,
                                      estimationNumber,
                                    })
                                  }
                                />
                              ))}
                            </TableBody>
                          )}
                        </Table>
                      </TableContainer>
                    )}
                  </CardContent>
                </Card>
              </>
            ) : (
              selectedIndex === 1 && <GanttChart />
            )}
          </Grid>
        </Grid>
        <Footer></Footer>
      </div>
      <SelectSubcontractorDialog
        open={ticketIdSubDialog !== undefined}
        onClose={() => setTicketIdSubDialog(undefined)}
        ticketId={ticketIdSubDialog}
        requireReason={subDialogRequiresReason}
        refreshData={fetchData}
      />
      <Dialog
        open={!!ticketId}
        onClose={() => setTicketId(undefined)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>チケット詳細</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setTicketId(undefined)}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          <TicketDetail ticketId={ticketId} />
        </DialogContent>
      </Dialog>

      <Dialog
        open={!!orderTicketId}
        onClose={() => setOrderTicketId(undefined)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>注文詳細</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setOrderTicketId(undefined)}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          <OrderDetails orderTicketId={orderTicketId} />
        </DialogContent>
      </Dialog>

      {/* 承認待ち顧客の承認画面（設計04） */}
      <Dialog
        open={!!selectedAccount}
        onClose={() => setSelectedAccount(null)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>顧客承認</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setSelectedAccount(null)}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          {selectedAccount && (
            <Stack spacing={1}>
              <Typography>
                <strong>登録日:</strong>{" "}
                {selectedAccount.created_at
                  ? new Date(selectedAccount.created_at).toLocaleString("ja-JP")
                  : "-"}
              </Typography>
              <Typography>
                <strong>ログインID:</strong> {selectedAccount.username}
              </Typography>
              <Typography>
                <strong>会社名:</strong> {selectedAccount.company_name || "-"}
              </Typography>
              <Typography>
                <strong>会社名（カナ）:</strong>{" "}
                {selectedAccount.company_name_ruby || "-"}
              </Typography>
              <Typography>
                <strong>氏名:</strong> {selectedAccount.fullname}
              </Typography>
              <Typography>
                <strong>氏名（カナ）:</strong>{" "}
                {selectedAccount.fullname_kana || "-"}
              </Typography>
              <Typography>
                <strong>メール:</strong> {selectedAccount.email}
              </Typography>
              <Typography>
                <strong>電話番号:</strong>{" "}
                {selectedAccount.phone_number || "-"}
              </Typography>
              <Typography>
                <strong>郵便番号:</strong>{" "}
                {selectedAccount.postal_code || "-"}
              </Typography>
              <Typography>
                <strong>住所:</strong> {selectedAccount.address || "-"}
              </Typography>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            color="error"
            disabled={approvalProcessing}
            onClick={() =>
              selectedAccount && handleApproval(selectedAccount, "reject")
            }
          >
            拒否
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={approvalProcessing}
            onClick={() =>
              selectedAccount && handleApproval(selectedAccount, "approve")
            }
          >
            承認
          </Button>
        </DialogActions>
      </Dialog>

      {/* 確定/拒否トースト（3秒・画面中央）。
          既定の画面下部だと固定フッター（高さ64px）と重なって見落とされるため、
          視線のある画面中央に表示する。
          MuiSnackbar は sm(600px)以上の位置指定を @media 内に持ち、stylis が
          @media を基本ルールより後ろに出力するため、sx の指定だけでは
          上書きできない。同じブレークポイントを明示して打ち消している。 */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() =>
          setToast((prev) => ({ ...prev, open: false, message: "" }))
        }
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={(theme) => ({
          ...CENTER_TOAST_POSITION,
          [theme.breakpoints.up("sm")]: { ...CENTER_TOAST_POSITION },
        })}
      >
        <Alert
          severity={toast.severity}
          onClose={() =>
            setToast((prev) => ({ ...prev, open: false, message: "" }))
          }
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>

      {/* 一括受注確定の確認ダイアログ */}
      <BulkConfirmDialog
        open={bulkConfirmOpen}
        onClose={() => setBulkConfirmOpen(false)}
        summary={selectedSummary}
        onConfirm={async () => {
          await executeBulk(TicketStatus.indexOf("COMPANY_ORDER_RECEIVED"));
          setBulkConfirmOpen(false);
        }}
      />

      {/* 一括受注拒否の理由入力モーダル（必須） */}
      <RejectReasonModal
        open={bulkReasonOpen && bulkReject}
        title="一括受注拒否"
        summary={selectedSummary}
        onClose={() => {
          setBulkReasonOpen(false);
          setBulkReject(false);
        }}
        onConfirm={async (reason) => {
          await executeBulk(
            TicketStatus.indexOf("COMPANY_ORDER_REJECTED"),
            reason
          );
          setBulkReasonOpen(false);
          setBulkReject(false);
        }}
      />

      {/* 単件受注拒否の理由入力モーダル（必須） */}
      <RejectReasonModal
        open={!!singleReject}
        title="受注拒否"
        estimationNumber={singleReject?.estimationNumber}
        fileName={singleReject?.ticket.file_name}
        onClose={() => setSingleReject(null)}
        onConfirm={async (reason) => {
          if (singleReject) {
            await executeSingleReject(singleReject.ticket.id, reason);
          }
          setSingleReject(null);
        }}
      />
    </>
  );
};

// 選択集計の型
type SelectedSummary = {
  count: number;
  totalQuantity: number;
  totalAmount: number;
  customerCounts: Record<string, number>;
};

// 一括受注確定の確認ダイアログ（対象件数・合計枚数・対象顧客を表示）
function BulkConfirmDialog({
  open,
  onClose,
  onConfirm,
  summary,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  summary: SelectedSummary;
}) {
  const [loading, setLoading] = useState(false);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold", color: "#3E6EB4" }}>
        一括受注確定
      </DialogTitle>
      <DialogContent dividers>
        <Typography>以下の内容で受注確定します。よろしいですか？</Typography>
        <Box sx={{ mt: 2 }}>
          <Typography>対象件数: {summary.count}件</Typography>
          <Typography>合計枚数: {summary.totalQuantity}枚</Typography>
          <Typography>
            合計金額: ¥{summary.totalAmount.toLocaleString()}
          </Typography>
          <Typography sx={{ mt: 1 }}>対象顧客:</Typography>
          {Object.entries(summary.customerCounts).map(([name, count]) => (
            <Typography key={name} variant="body2" sx={{ ml: 2 }}>
              ・{name}: {count}件
            </Typography>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          sx={{ color: "#3C3C43", opacity: 0.6 }}
          onClick={onClose}
        >
          キャンセル
        </Button>
        <Button
          variant="contained"
          onClick={async () => {
            setLoading(true);
            try {
              await onConfirm();
            } finally {
              setLoading(false);
            }
          }}
        >
          {loading ? <CircularProgress size={20} /> : "受注確定"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// 受注拒否理由入力モーダル（単件・一括共通、理由必須・空で確定無効）
function RejectReasonModal({
  open,
  onClose,
  onConfirm,
  title,
  estimationNumber,
  fileName,
  summary,
  actionLabel = "受注拒否",
  description = "受注拒否の理由を入力してください（必須）。理由は顧客の注文詳細に表示されます。",
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
  title: string;
  estimationNumber?: string;
  fileName?: string;
  summary?: SelectedSummary;
  actionLabel?: string;
  description?: string;
}) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const trimmed = reason.trim();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold", color: "#B85450" }}>
        {title}
      </DialogTitle>
      <DialogContent dividers>
        {summary && (
          <Box sx={{ mb: 2 }}>
            <Typography>対象件数: {summary.count}件</Typography>
            <Typography>合計枚数: {summary.totalQuantity}枚</Typography>
            <Typography>
              合計金額: ¥{summary.totalAmount.toLocaleString()}
            </Typography>
            <Typography sx={{ mt: 1 }}>対象顧客:</Typography>
            {Object.entries(summary.customerCounts).map(([name, count]) => (
              <Typography key={name} variant="body2" sx={{ ml: 2 }}>
                ・{name}: {count}件
              </Typography>
            ))}
          </Box>
        )}
        {estimationNumber && (
          <Typography sx={{ mb: 2 }}>
            注文「{estimationNumber}」のファイル「{fileName}」を{actionLabel}します。
          </Typography>
        )}
        <Typography variant="body2" sx={{ mb: 1 }}>
          {description}
        </Typography>
        <TextField
          multiline
          minRows={3}
          fullWidth
          value={reason}
          placeholder={`${actionLabel}の理由を入力`}
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          sx={{ color: "#3C3C43", opacity: 0.6 }}
          onClick={onClose}
        >
          キャンセル
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={!trimmed || loading}
          onClick={async () => {
            setLoading(true);
            try {
              await onConfirm(trimmed);
            } finally {
              setLoading(false);
            }
          }}
        >
          {loading ? <CircularProgress size={20} /> : actionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface SearchInput {
  fullname: string;
  username: string;
  [key: string]: string;
}

function SelectSubcontractorDialog({
  open,
  onClose,
  ticketId,
  requireReason,
  refreshData,
}: {
  open: boolean;
  onClose: () => void;
  ticketId?: string;
  requireReason: boolean;
  refreshData: () => {};
}) {
  const [subcontractorId, setSubcontractorId] = useState<string>();
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const columns: GridColDef[] = [
    {
      field: "select",
      headerName: "",
      flex: 0.1,
      sortable: false,
      renderCell: (params) => (
        <Checkbox
          color="primary"
          checked={subcontractorId === params.row.id}
          onChange={(e) => {
            setSubcontractorId(params.row.id);
          }}
        />
      ),
    },
    {
      field: "id",
      headerName: "ID",
      flex: 0.2,
    },
    {
      field: "username",
      headerName: "ログインID",
      flex: 0.3,
    },
    {
      field: "fullname",
      headerName: "氏名",
      flex: 0.3,
    },

    {
      field: "email",
      headerName: "メールアドレス",
      flex: 0.3,
    },
    {
      field: "phone_number",
      headerName: "電話番号",
      flex: 0.3,
    },
  ];
  const [data, setData] = useState([]);
  const [searchInput, setSearchInput] = useState<Partial<SearchInput>>({
    fullname: "",
    username: "",
  });
  const [fullnameList, setFullnameList] = useState<string[]>([]);
  const [usernameList, setUsernameList] = useState<string[]>([]);

  const fetchData = async (search = "") => {
    let url = "/dashboard/orders/subcontractor";
    if (search !== "") {
      url += `?${search}`;
    }
    await axiosConfig.get(url).then((res) => {
      setFullnameList(res.data.body.data.map((item: any) => item.fullname));
      setUsernameList(res.data.body.data.map((item: any) => item.username));
      setData(res.data.body.data);
    });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean>();

  const handleChangeSearchInput = (value: string, field: string) => {
    setSearchInput((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSearch = async () => {
    let searchUrl = "";
    const keys = Object.keys(searchInput);
    keys.forEach((key) => {
      if (searchInput[key] !== "") {
        if (searchUrl.length === 0) searchUrl += `${key}=${searchInput[key]}`;
        else searchUrl += `&${key}=${searchInput[key]}`;
      }
    });
    await fetchData(searchUrl);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onCloseDialog = () => {
    setSubcontractorId(undefined);
    if (searchInput.fullname || searchInput.username) {
      setSearchInput({
        fullname: "",
        username: "",
      });
      fetchData();
    }
    onClose();
  };

  const assignSubcontractor = async ({
    subcontractorId,
    ticketId,
  }: {
    subcontractorId: string;
    ticketId: string;
  }) => {
    setIsLoading(true);
    try {
      await axiosConfig.post(`/dashboard/assign-tickets`, {
        ticket_ids: [ticketId],
        subcontractor_id: subcontractorId,
        reason: requireReason ? reason.trim() : undefined,
      });
      setIsSuccess(true);
      refreshData();
    } catch (error) {
      console.error(error);
      setIsSuccess(false);
    }
  };

  return (
    <>
      <LoadingDialog
        isOpen={isLoading}
        message={"処理中"}
        isSuccess={isSuccess}
        onClose={() => {
          setIsLoading(false);
          setTimeout(() => {
            setIsSuccess(undefined);
          }, 1000);
        }}
      />
      <Dialog
        onClose={() => {
          onCloseDialog();
        }}
        aria-labelledby="select-subcontractor-dialog"
        open={open}
        maxWidth={"md"}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="select-subcontractor-dialog">
          協力会社選択
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            onCloseDialog();
          }}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          <Card className="mx-auto" sx={{ border: 1, borderColor: "grey.300" }}>
            <CardHeader sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }} />
            <CardContent sx={{ paddingY: "5px" }}>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <h3>氏名</h3>
                  <Autocomplete
                    freeSolo
                    className="mt-1"
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} />}
                    options={fullnameList}
                    value={searchInput.fullname}
                    onInputChange={(e, value) =>
                      handleChangeSearchInput(value, "fullname")
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <h3>ログインID</h3>
                  <Autocomplete
                    freeSolo
                    className="mt-1"
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} />}
                    options={usernameList}
                    value={searchInput.username}
                    onInputChange={(e, value) =>
                      handleChangeSearchInput(value, "username")
                    }
                  />
                </Grid>
              </Grid>
              <Stack className="mt-2">
                <div className="ml-auto">
                  <Button variant="contained" onClick={handleSearch}>
                    検索
                  </Button>
                </div>
              </Stack>
            </CardContent>
          </Card>
          <Card
            className="mx-auto mt-5 mb-4"
            sx={{ border: 1, borderColor: "grey.300" }}
          >
            <CardHeader sx={{ bgcolor: "#F5F5F5", padding: "12px" }} />
            <CardContent>
              <DataGrid
                localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                rows={data}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                }}
                pageSizeOptions={[10, 20, 30]}
                disableColumnMenu
                disableColumnSorting
                disableRowSelectionOnClick
              />
              {data.length === 0 && (
                <Typography variant="subtitle1" align="center" sx={{ mt: 2 }}>
                  データがありません
                </Typography>
              )}
            </CardContent>
          </Card>
          {requireReason && (
            <Box>
              <Typography variant="body2" sx={{ mb: 1 }}>
                お客様から受入拒否された図面です。協力会社への差し戻し理由を入力してください（必須）。理由は協力会社にメールで届き、やりとり欄に残ります（お客様には表示されません）。
              </Typography>
              <TextField
                multiline
                minRows={3}
                fullWidth
                value={reason}
                placeholder="差し戻しの理由を入力"
                onChange={(e) => setReason(e.target.value)}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            sx={{ paddingX: "30px" }}
            disabled={requireReason && !reason.trim()}
            onClick={() => {
              assignSubcontractor({
                subcontractorId: subcontractorId!,
                ticketId: ticketId!,
              });
              onCloseDialog();
            }}
          >
            発注する
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function AssignAllTicketsButton({
  ticketIds,
  refreshData,
}: {
  ticketIds: string[];
  refreshData: () => {};
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean>();

  const assignAllTickets = async () => {
    const url = "/dashboard/assign-tickets";
    setIsLoading(true);
    try {
      await axiosConfig.post(url, {
        ticket_ids: ticketIds,
      });
      setIsSuccess(true);
      refreshData();
    } catch (error) {
      console.error(error);
      setIsSuccess(false);
    }
  };

  return (
    <>
      <LoadingDialog
        isOpen={isLoading}
        message={"処理中"}
        isSuccess={isSuccess}
        onClose={() => {
          setIsLoading(false);
          setTimeout(() => {
            setIsSuccess(undefined);
          }, 1000);
        }}
      />

      <Button
        variant="contained"
        size="small"
        disableRipple
        disabled={ticketIds.length === 0}
        onClick={assignAllTickets}
      >
        すべてのチケットを発注
      </Button>
    </>
  );
}

export default EmployeeDashboard;
